
import { Visual } from "./visual";

/** test if the interface we have is a Rectangle */
export function isRectangle(obj: any): obj is Rectangle {

  return (obj as Rectangle).isRectangle !== undefined;
}

/**
 *
 * @class Rectangle
 *
 * specifies how to render some part of a canvas object.  The canvas adaptor we are
 * currently using must then render an appropriate object to the actual canvas.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2024
 *
 */
export interface Rectangle extends Visual {

  /** type guard */
  isRectangle: () => void;

  /** horizontal position */
  x?:               number;

  /** vertical position */
  y?:               number;

  /** horizontal extend */
  width?:           number;

  /** vertical extent */
  height?:          number;

  /** rounding for corners (in pixels) */
  cornerRadius?:    number;

  /** the fill color */
  backgroundColor?: string;

  /** the stroke color */
  borderColor?:     string;

  /** the stroke width */
  borderWidth?:     number;

  /** drawn or not */
  visible?:         boolean;

  /** transparency (transparent) 0.0 ... 1.0 (not transparent) */
  opacity?:         number;

}
